export class PropertyManagementDTO{
    public id?:number;
    public propertyId!:number;
    public managementType!:string;
    public management!:string; //json
}